(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-display"]) return;
  try {
    
  addEventListener("DOMContentLoaded",()=>{
    const collectionDisplays= document.querySelectorAll(".collection-display");
    collectionDisplays.forEach(collectionDisplay => {
      new Swiper(collectionDisplay,{
        spaceBetween: 20,
        slidesPerView: 1.1,
        breakpoints:{
          469: {
            slidesPerView: 1.5
          },
          768: {
            slidesPerView: 2.3
          },
          992: {
            slidesPerView: 4
          }
        }
      })
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class ProductFilters extends HTMLElement {
    constructor() {
      super();
      this.activated = true;
    }
    connectedCallback(){
      this.sectionID= this.dataset.sectionId;
      this.sortByEl= document.querySelector("select.product-sort-by");
      this.section= document.querySelector(`#shopify-section-${this.sectionID}`);
      this.inputs= this.querySelectorAll("input");
      this.activate();
    }

    activate(){
      this.activated= true;
      this.inputs.forEach(input=>{
        input.addEventListener('change',this.handleChange)
      });
      this.sortByEl.addEventListener('change',this.sortChange)
    }

    url = new URL(window.location.href);
    timeout= null;

    debounceUpdateOnChange(){
      const url = this.url;
      if(this.timeout)clearTimeout(this.timeout);
      this.timeout= setTimeout(() => {
        this.updateOnChange(url)
      }, 350);
    }

    handleChange= (e)=>{
      const input= e.target;
      this.url.searchParams.set("section_id", this.sectionID);
      if(input.type == "checkbox" && input.checked){
        this.url.searchParams.append(input.dataset.paramName,input.value);
      }else if(input.type == "checkbox"){
        this.url.searchParams.delete(input.dataset.paramName,input.value);
      }else{
        this.url.searchParams.append(input.dataset.paramName,input.value);
      }

      this.debounceUpdateOnChange()
    }

    sortChange= (e)=>{
      this.url.searchParams.set(this.sortByEl.name,e.target.value);

      this.debounceUpdateOnChange()
    }

    updateOnChange(url){
      fetch(url.toString())
      .then(response=>{
        return response.text();
      })
      .then(htmlText=>{
        const parser= new DOMParser();
        const html= parser.parseFromString(htmlText,"text/html");

        // this.section.querySelector(".filter-header").innerHTML= html.querySelector(".filter-header").innerHTML;
        this.section.querySelector(".filtered-products").innerHTML= html.querySelector(".filtered-products").innerHTML;
        // this.section.querySelector(".filter-pages").innerHTML= html.querySelector(".filter-pages").innerHTML;
        const newURL= new URL(url);
        newURL.searchParams.delete("section_id");
        history.pushState(null,"",newURL.toString());
        this.section.querySelector(".filter-dropdowns").innerHTML= html.querySelector(".filter-dropdowns").innerHTML;
      });
    }
  }
  customElements.define("product-filters",ProductFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  // addEventListener("DOMContentLoaded",()=>{
  //   const dialog= document.querySelector(".newsletter-dialog");
  //   const closeBtn= document.querySelector(".newsletter-close-button");
  //   const form= document.querySelector(".newsletter-form");

  //   setTimeout(() => {
  //     const emailSent= !!(localStorage.getItem("newsletter"));
  //     const inEditor = window.Shopify && Shopify.designMode;

  //     if(!emailSent && !inEditor){
  //       dialog.showModal();
  //     }
  //   }, 4000);
  //   closeBtn.addEventListener("click",e=>{
  //     dialog.close();
  //   })

  //   form.addEventListener("submit",async(e)=>{
  //     e.preventDefault();
  //     const formData = new FormData(form);
  //     const formAction = form.getAttribute('action');
  //     try {
  //       const response= await fetch(formAction,{
  //         method: "POST",
  //         body: formData
  //       })
  //       if(response.ok){
  //         dialog.close();
  //         localStorage.setItem("newsletter","true")
  //       }
  //     } catch (error) {
        
  //     }
  //   })
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  addEventListener("DOMContentLoaded",()=>{
    const thumbSwiper= new Swiper(".product-hero-media-thumbs",{
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 16
    })
    const productImageSwiper= new Swiper(".product-hero-media-swiper",{
      // direction: "vertical",
      spaceBetween: 16,
      thumbs: {
        swiper: thumbSwiper
      }
    });
  })

  } catch(e) { console.error(e); }
})();
})();
